import mutations from "./mutations"
import getters from "./getters"
import { initialState } from "./state"
import actions from "./actions"

export default {
  namespaced: true,
  state: initialState,
  mutations,
  getters,
  actions
}
